module.exports = __webpack_public_path__ + "8a5356e9/img/send-icon.3cfb6275.svg";